import React from "react"
import {useProgress} from "../../AppContext"
import {iconPanDown, iconPanLeft, iconPanRight, iconPanTop, iconZoomFit, iconZoomIn, iconZoomOut} from "../../Helper/Icons"
import style from "./Control.css"

export const Control = () => {
    const progress = useProgress()
    const hide = progress.isSolution()
        ? {display: "none"}
        : null;

    return <div className={style.control}>
        <div id="canvasControlZoomIn">{iconZoomIn}</div>
        <div id="canvasControlZoomOut">{iconZoomOut}</div>
        <div id="canvasControlZoomFit" style={hide}>{iconZoomFit}</div>
        <div id="canvasControlPanTop">{iconPanTop}</div>
        <div id="canvasControlPanDown">{iconPanDown}</div>
        <div id="canvasControlPanLeft">{iconPanLeft}</div>
        <div id="canvasControlPanRight">{iconPanRight}</div>
    </div>
}
